
import './App.css';
import Weather from './Weather';

export default function App() {
  return (
    <div className="Weather App">
      <div className='container'>
      <Weather defaultCity="Kyiv"/>
     
<footer> 
  This project was coded by Svitlana Dolinta and is
      <a href="https://github.com/SvitlaM/weather-application" target="_blank" rel="noreferrer"> open sourced on GitHub</a>
      
      </footer>
      </div>
  
    </div>
  );
}

 
